import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, Toast, ListGroup, Form, Button, Alert } from 'react-bootstrap';
import MiniLoader from './../../../../utilityComponents/MiniLoader';
import Message from './../../../../utilityComponents/Message';
import { fetchAvailableKPI,
        setSpecificKPI,
        selectAllAvailableKPI,
        deselectAllAvailableKPI,
        downloadKPIFiles } from './../../../../actions/closeLoop/kpiDashboard/download/downloadReportsActions';
import PropTypes from 'prop-types';

function KPIList(props) {
    const [ toggleText, setToggleText ] = useState("Deselect All");
    const [ isOneKPISelected, setIsOneKPISelected ] = useState(false);

    useEffect(() => {
        if (props.bench && props.testRunId && props.scenarioUUID) {
            const payload = {
                bench_name: props.bench,
                test_run_id: props.testRunId,
                scenario_uuid: props.scenarioUUID
            }
            props.fetchAvailableKPIList(payload);
        }
    }, [])

    const onCheck = (event) => {
        const payload = {
            kpi: event.target.id,
            checked: event.target.checked
        }
        props.enableSpecificKPI(payload);
    }

    const handleToggle = (event) => {
        const label = event.target.innerHTML;
        if (label === 'Deselect All') {
            setToggleText('Select All');
            props.deselectAllAvailableKPIList();
        } else if (label === 'Select All') {
            setToggleText('Deselect All');
            props.selectAllAvailableKPIList();
        } else {
            console.log(label);
        }
    }

    const kpiFileHandler = () => {
        const enabledKPIs = props.kpiList.filter(info => info['enabled']);
        if (enabledKPIs.length === 0) {
            setIsOneKPISelected(true)
        } else {
            const selectedKPIs = props.kpiList.filter(
                (info) => info['enabled']).map((info) => info['value']);
            const payload = {
                bench_name: props.bench,
                test_run_id: props.testRunId,
                scenario_uuid: props.scenarioUUID,
                kpi: selectedKPIs
            }
            props.downloadKPIReports(payload);
        }
    }

    return (
        <>
            { isOneKPISelected ? (
                <Alert variant="info" onClose={() => setIsOneKPISelected(false)} dismissible>
                    <Alert.Heading>Message!</Alert.Heading>
                    <p>
                        Please select atleast one <strong>KPI</strong> to download.
                    </p>
                </Alert>
            ) : (
                <Toast show={props.show}>
                    <Card>
                        <Card.Header>
                            <Row>
                                <Col md={10} xl={10} className="align-self-center">
                                    <strong className="me-auto">Available KPIs</strong>
                                </Col>
                                <Col md={2} xl={2} className="align-self-center">
                                    <Button
                                        className='text-right'
                                        variant='light'
                                        onClick={props.handleClose}
                                    >
                                        x
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Header>
                    </Card>
                    { props.loading ?
                        <MiniLoader /> :
                         props.error ? (
                            <Message variant={'danger'}>
                                { props.error }
                            </Message>
                         ) : (
                            <Row>
                                <Col md={12} xl={12}>
                                    <Card>
                                        { props.kpiList.length > 0 && (
                                            <Card.Header>
                                                <Row>
                                                    <Col md={12} xl={12} className="align-items-left">
                                                        <Button
                                                            variant={'dark'}
                                                            onClick={ (e) => handleToggle(e) }
                                                        >
                                                            { toggleText }
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card.Header>
                                        ) }
                                        <Card.Body
                                            style={
                                                props.kpiList.length === 0 ? {} :
                                                { height: '300px', overflowY: 'scroll' }
                                            }
                                        >
                                            <Row>
                                                <Col md={12} xl={12} className='text-center'>
                                                    { props.kpiList.length === 0 ? (
                                                        <Message variant={'info'}>
                                                            No KPIs Found
                                                        </Message>
                                                    ) : (
                                                        <>
                                                            <ListGroup style={{ paddingTop: '1rem' }}>
                                                                { props.kpiList.map((kpiInfo, index) => {
                                                                    return (
                                                                        <ListGroup.Item
                                                                            key={`${kpiInfo['value']}-${index}`}
                                                                        >
                                                                            <Form.Check
                                                                                type='checkbox'
                                                                                label={kpiInfo['label']}
                                                                                id={kpiInfo['value']}
                                                                                onChange={onCheck}
                                                                                checked={kpiInfo['enabled']}
                                                                            />
                                                                        </ListGroup.Item>
                                                                    )
                                                                }) }
                                                            </ListGroup>
                                                        </>
                                                    ) }
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        { props.kpiList.length > 0 && (
                                            <Card.Footer>
                                                <Row>
                                                    <Col md={12} xl={12} className="text-center">
                                                        <Button
                                                            variant={'primary'}
                                                            onClick={ () => { kpiFileHandler() } }
                                                        >
                                                            Download
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card.Footer>
                                        ) }
                                    </Card>
                                </Col>
                            </Row>
                         )}
                </Toast>
            ) }
        </>
    )
}

KPIList.propTypes={
    kpiList:PropTypes.array,
    bench:PropTypes.string,
    testRunId:PropTypes.string,
    scenarioUUID:PropTypes.string,
    fetchAvailableKPIList:PropTypes.func,
    enableSpecificKPI:PropTypes.func,
    deselectAllAvailableKPIList:PropTypes.func,
    selectAllAvailableKPIList:PropTypes.func,
    downloadKPIReports:PropTypes.func,
    show:PropTypes.bool,
    handleClose:PropTypes.func,
    loading:PropTypes.bool,
    error:PropTypes.string
}

const mapStateToProps = (state) => ({
    loading: state.availableKPIList.loading,
    error: state.availableKPIList.error,
    kpiList: state.availableKPIList.kpiList,
    bench: state.dashboardFilterData.info.selectData.benchName,
    testRunId: state.dashboardFilterData.info.selectData.runId,
    scenarioUUID: state.dashboardFilterData.info.selectData.scenarioId,
})

const mapDispatchToProps = (dispatch) => ({
    fetchAvailableKPIList: (payload) => dispatch(fetchAvailableKPI(payload)),
    enableSpecificKPI: (payload) => dispatch(setSpecificKPI(payload)),
    selectAllAvailableKPIList: () => dispatch(selectAllAvailableKPI()),
    deselectAllAvailableKPIList: () => dispatch(deselectAllAvailableKPI()),
    downloadKPIReports: (payload) => dispatch(downloadKPIFiles(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(KPIList);